<template>
    <div class="has-text-center section">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns">
            <div class="column is-one-third cart-col" >
                <CartDetail
                :cartDetail="cartDetail"
                @fetchCart="fetchCartDetail"
                :loading="loading"
                />
            </div>
            <div class="column is-two-thirds">
                <b-steps
                v-model="activeStep"
                :has-navigation="false"
                type="is-black">

                    <b-step-item label="Datos de envio y Facturacion" :clickable="orderClickable" >
                        <OrderData
                        :userEmail="userEmail"
                        :userProfile="userProfile"
                        :envios="envios"
                        :cart="cartDetail"
                        :nextSectionName="hasCustomFields == 'True' ? customFieldsName : 'Confirmacion y pago'"
                        :deliveryDateControl="deliveryDateControl"
                        @orderData="processOrderData"
                        />
                    </b-step-item>

                    <b-step-item v-if="hasCustomFields == 'True'" :label="customFieldsName">
                        <CustomForm 
                        :fields="customFields" 
                        @customData="processCustomFormData"    
                        />
                    </b-step-item>

                    <b-step-item label="Confirmacion y pago" :clickable="paymentClickable">
                        <Payment
                        :couponFind="couponFind"
                        :mpBool="mpBool"
                        :ppMinOrder="ppMinOrder"
                        :mpMinOrder="mpMinOrder"
                        :cashBool="cashBool"
                        :transferBool="transferBool"
                        :paypalBool="paypalBool"
                        :cartDetail="cartDetail"
                        :mpPubKey="mpPubKey"
                        :manualValidation="manualValidation"
                        :amountUsd="amountUsd"
                        :amountUy="amountUy"
                        :shipmentTotalUy="shipmentCostUy"
                        :shipmentTotalUsd="shipmentCostUsd"
                        :orderPlusShipping="orderPlusShipping"
                        :usdReportsBool="usdReportsBool"
                        :channels="channels"
                        :bambooChannel="bambooChannel"
                        :bambooClientId="bambooClientId"
                        :bambooKey="bambooKey"
                        :bambooMethods="bambooMethods"
                        @payment="paymentData"
                        />
                        <hr/>
                        <div class="has-text-centered">
                            <p class="title is-size-4">Se enviara a</p>
                            <p v-if="orderData.shipmentMethod == 'retiro'"> Retira en local</p>
                            <p v-if="orderData.shipmentMethod == 'dac'">Envio por agencia</p>
                            <p>{{orderData.email}}</p>
                            <p>{{orderData.firstName}} {{orderData.lastName}} - {{orderData.idNumber}} - {{orderData.phoneNumber}}</p>
                            <p>{{orderData.address}} {{orderData.number}} {{orderData.zipCode}}. {{orderData.location}}, {{orderData.region}}</p>
                        </div>
                        
                    </b-step-item>

                    <b-step-item label="Final" :clickable="finalClickable">
                        <FinalStep
                        :orderData="orderData"
                        :userEmail="userEmail"
                        :payment="payment"
                        :manualValidation="manualValidation"
                        :channels="channels"/>
                    </b-step-item>

                </b-steps>
            </div>
        </div>
    </div>
</template>

<script>
import {getHandler, postHandler} from "./../../../services/http"
import OrderData from "./components/OrderData.vue"
import Payment from "./components/Payment.vue"
import CartDetail from "./components/CartDetail.vue"
import CustomForm from "./components/CustomForm.vue"
import FinalStep from "./components/FinalStep.vue"


export default {
    components:{
        OrderData,
        Payment,
        CartDetail,
        FinalStep,
        CustomForm
    },
    props:{
        userEmail:{
            type:String,
            default:""
        },
        userProfileUrl:{
            type:String,
            default:""
        },
        cartDetailUrl:{
            type:String,
            default:""
        },
        channelList:{
            type:String,
            default:""
        },
        mpChannel:{
            type:String,
            default:""
        },
        transferChannel:{
            type:String,
            default:""
        },
        paypalChannel:{
            type:String,
            default:""
        },
        cashChannel:{
            type:String,
            default:""
        },
        shipmentListUrl:{
            type:String,
            default:""
        },
        mpPubKey:{
            type:String,
            default:""
        },
        manualValidation:{
            type:String,
            default:""
        },
        couponFind:{
            type:String,
            default:""
        },
        mpMinOrder:{
            type:String,
            default:""
        },
        ppMinOrder:{
            type:String,
            default:""
        },
        usdReports:{
            type:String,
            default:""
        },
        hasCustomFields:{
            type:String,
            default:""
        },
        customFieldsName:{
            type:String,
            default:""
        },
        customFieldsUrl:{
            type:String,
            default:""
        },
        deliveryDateControl:{
            type:String,
            default:""
        },
        universalCheckout:{
            type:String,
            default:""
        },
        bambooChannel:{
            type:String,
            default:""
        },
        bambooClientId:{
            type:String,
            default:""
        },
        bambooKey:{
            type:String,
            default:""
        },
        bambooMethodsUrl:{
            type:String,
            default:""
        },
        bambooUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            activeStep:0,
            order:{},
            orderData:{},
            payment:{},
            cartDetail:{},
            customFormData:[],
            loading:false,
            channels:[],
            userProfile:{},
            envios:[],
            shipmentCostUy:0,
            shipmentCostUsd:0,
            orderTotalUy:0,
            orderTotalUsd:0,
            amountUy:0,
            amountUsd:0,
            customFields:[],
            bambooMethods:[]
        }
    },
    methods:{
        processOrderData(data, shipmentCost){
            this.orderData = data
            if(this.deliveryDateControl != 'True'){
                delete this.orderData.deliveryDate 
            }
            this.shipmentCostUy = shipmentCost
            this.shipmentCostUsd = parseFloat(parseFloat(shipmentCost / this.cartDetail.usdVal).toFixed(2))
            this.orderTotalUy = this.cartDetail.totalInUy
            this.orderTotalUsd = this.cartDetail.totalInUsd
            this.amountUy = this.orderTotalUy + shipmentCost
            this.amountUsd = this.orderTotalUsd + this.shipmentCostUsd
            this.activeStep = this.activeStep + 1
            window.scrollTo(0, 0);
        },
        processCustomFormData(data){
            this.customFormData = data
            this.activeStep = this.activeStep + 1
        },
        async fetchUserProfile(){
            if(this.userEmail){
                let res = await getHandler(this.userProfileUrl, {error:false, success:false})
                this.userProfile = res
            }
        },
        async fetchBambooMethods(){
            this.bambooMethods= await getHandler(this.bambooMethodsUrl, {error:false, success:false})
        },
        async fetchChannels(){
            var type = ''
            if (this.payment != {} && this.payment.method != undefined){
                type = this.payment.method
            }
            var url = this.channelList + "?type=" + type
            this.channels = await getHandler(url, {error:false, success:false})
        },
        asciiBuilder(string){
            var array = []
            for (var x in string){
                array.push(x.charCodeAt().toString(2).padStart(7, '0'))
            }
            return array
        },
        stringToUint(string) {
            var string = btoa(unescape(encodeURIComponent(string))),
                charList = string.split(''),
                uintArray = [];
            for (var i = 0; i < charList.length; i++) {
                uintArray.push(charList[i].charCodeAt(0));
            }
            return new Uint8Array(uintArray);
        },

        uintToString(uintArray) {
            var encodedString = String.fromCharCode.apply(null, uintArray),
                decodedString = decodeURIComponent(escape(atob(encodedString)));
            return decodedString;
        },
        bambooFormBuilder(data){
            var docType = 1
            if (data.orderData.idType == "CI"){
                docType = 1
            } else if (data.orderData.idType != "P"){
                docType = 2
            }
            var initialDate = new Date(data.order.timestamp)
            var dd = String(initialDate.getDate()).padStart(2, '0');
            var MM = String(initialDate.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = String(initialDate.getFullYear())
            var hh = String(initialDate.getHours()).padStart(2, '0')
            var mm = String(initialDate.getMinutes()).padStart(2, '0')
            var ss = String(initialDate.getSeconds()).padStart(2, '0')
            var fecha = yyyy + "-" + MM + "-" + dd + hh + ":" + mm + ":" + ss
            var dataObj = {
                idCliente:this.bambooClientId,
                idTarjetaCredito:data.paymentData.bambooMethod,
                primerNombre:data.orderData.firstName,
                primerApellido:data.orderData.lastName,
                cedula:data.orderData.idNumber,
                email:data.orderData.email,
                telefono:data.orderData.phoneNumber,
                direccionEnvio:data.orderData.address,
                valorTransaccion:data.paymentData.amountUy,
                cantidadCuotas:1,
                moneda:858,
                numeroOrden:data.order.id,
                version:3.4,
                plan:0,
                fecha:fecha,
                consumidorFinal:1,
                importeGravado:data.paymentData.amountUy,
                numeroFactura:data.order.id,
                tipoDocumento:docType,
            }

            var initialVector =  yyyy.substring(3) + MM + dd + hh + mm + ss +"="
            //console.log(data.key, data.vector)
            
            //var finalKey = CryptoJS.TripleDES.encrypt(
            //    data.fullString, 
            //    data.key,
            //    {
            //        iv: data.vector,
            //        mode: CryptoJS.mode.CBC
            //    })
            //console.log(CryptoJS.enc.Base64.parse(finalKey.toString()))
            dataObj["transactionSecurityToken"] = data.securityToken
            var bambooForm = document.createElement("form")
            bambooForm.setAttribute("method", "POST")
            bambooForm.setAttribute("action", this.bambooUrl)
            bambooForm.setAttribute("id", "bamboFormId")
            var keys = Object.keys(dataObj)
            keys.forEach(el=>{
                let i = document.createElement("input")
                i.setAttribute("name", el)
                i.setAttribute("value", dataObj[el])
                bambooForm.appendChild(i)
            })
            let sumbmitPut = document.createElement("input")
            sumbmitPut.setAttribute("type", "submit")
            sumbmitPut.setAttribute("name", "btnSubmit")
            sumbmitPut.setAttribute("value", "submit")
            document.body.appendChild(bambooForm);
            bambooForm.submit()
        },  
        async paymentData(data){
            this.loading = true
            this.payment = data
            var success = {
                resource:'notify',
                text:'Listo! Pago creado con exito!'
            }
            var error = {
                resource:'notify',
                text:'No se pudo procesar el pago. intenta con otra tarjeta, u otro medio de pago.'
            }
            
            var orderReqBody = {
                order:this.order,
                orderData:this.orderData,
                payment:this.payment,
            }

            if(this.hasCustomFields){
                orderReqBody['orderCustomData'] = this.customFormData
            }
            let resp = await postHandler(this.universalCheckout, orderReqBody, {success, error})
            
            this.fetchChannels()
            this.loading = false
            if (resp.status == 200 || resp.status == 201){
                this.activeStep = this.activeStep + 1
                window.scrollTo(0, 0);
                localStorage.setItem("cartCount", 0)
                var event = document.createEvent("Event");
                event.initEvent("storage", true, true);
                window.dispatchEvent(event);

                if (resp.data.paymentData.method == "bp"){
                    this.bambooFormBuilder(resp.data)
                }
                else if (resp.data.paymentData.method == "mp"){
                    window.location.href = resp.data.preference.initPoint
                }
            }
        },
        async fetchCartDetail(){
            this.loading = true
            this.cartDetail = await getHandler(this.cartDetailUrl, {error:false, success:false})
            this.envios = await getHandler(this.shipmentListUrl, {error:false, success:false})
            this.cartDetail.items.forEach((el)=>{
                el.quantity = parseInt(el.quantity)
            })
            localStorage.setItem("cartCount", this.cartDetail.itemCount)
            var event = document.createEvent("Event");
            event.initEvent("storage", true, true);
            window.dispatchEvent(event);
            this.loading = false
            this.order["cart"] = this.cartDetail.id
            this.orderPlusShipping = this.cartDetail.totalAmountUy
        },
        async fetchEnvios(){
            this.loading=true
            this.envios = await getHandler(this.shipmentListUrl, {error:false, success:false})
            this.loading=false
        },

        async fetchCustomFields(){
            this.loading = true
            var response = await getHandler(this.customFieldsUrl, {error:false, success:false})
            this.customFields = response
            this.loading = false
        }

    },
    computed:{
        usdReportsBool(){
            return this.usdReports == "True"
        },
        paymentClickable(){
            return 2 > this.activeStep & this.activeStep >= 1
        },
        finalClickable(){
            return 2 > this.activeStep & this.activeStep >= 2
        },
        orderClickable(){
            return 2 > this.activeStep & this.activeStep >= 0
        },
        mpBool(){
            return this.mpChannel == "True"
        },
        mpQRBool(){
            return this.mpQRChannel == "True"
        },
        mpQRD(){
            return parseInt(this.mpQRDiscount)
        },
        transferBool(){
            return this.transferChannel == "True"
        },
        paypalBool(){
            return this.paypalChannel == "True"
        },
        cashBool(){
            return this.cashChannel == "True"
        }
    },
    created(){
        this.fetchBambooMethods()
        this.fetchCartDetail()
        this.fetchUserProfile()
        this.fetchChannels()
        //this.fetchEnvios()
        if (this.hasCustomFields == 'True'){
            this.fetchCustomFields()
        }
    }
}
</script>

<style lang="scss" scoped>

.cart-col{
    background:rgb(246, 246, 246);
}

</style>